import React from 'react';

import * as styles from './footer.module.scss';
import { trackEvent } from '@vitl-services/services/analytics/tracking';
import { useImage } from '@hooks/useImage';
import ResponsiveResolutionImage from '@components/responsive-resolution-image/responsive-resolution-image';

interface IProps {
  content: {
    logo: string;
    navigation_links: Array<{
      label: string;
      path: string;
    }>;
    navigation_links_2: Array<{
      label: string;
      path: string;
    }>;
    social_links_label: string;
    social_links: Array<{
      icon: string;
      url: string;
    }>;
  };
}

const Footer: React.FC<IProps> = ({ content }) => {
  const hipaaImage = useImage(['icons/hipaa-light.png']);
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.logo}>
            <ResponsiveResolutionImage
              url={content.logo}
              title={'Vitl logo'}
              width={98}
              height={60}
            />
            <hr className={styles.hrMobile} />
          </div>

          <ul className={styles.navLinks}>
            {content.navigation_links.map(item => (
              <li key={item.path}>
                {item.path.includes(process.env.GATSBY_VITL_HOST_NAME!) ? (
                  <a className={styles.link} href={item.path} rel="noopener">
                    {item.label}
                  </a>
                ) : (
                  <a
                    className={styles.link}
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.label}
                  </a>
                )}
              </li>
            ))}
          </ul>

          <hr className={styles.hrMobile} />

          <ul className={styles.navLinks}>
            {content.navigation_links_2.map(item => (
              <li key={item.path}>
                <a className={styles.link} href={item.path} rel="noopener">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <hr className={styles.hrMobile} />

          <div>
            <div className={styles.navLinks}>
              <p className={styles.socialHeading}>
                {content.social_links_label}
              </p>
              <ul>
                {content.social_links.map(item => (
                  <li key={item.url} className={styles.socialItem}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener"
                      onClick={() => {
                        // analytics
                        trackEvent('Click CTA', {
                          cta_name: item.icon,
                          cta_category: 'social links',
                        });
                      }}
                    >
                      <ResponsiveResolutionImage
                        url={useImage([`icons/icon_${item.icon}.svg`])}
                        title={item.icon}
                        width={17}
                        height={17}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <hr className={styles.hr} />
        <div className={styles.subFooter}>
          <ul className={styles.bottomColLeft}>
            <li>
              <small className={styles.copyright}>
                © {new Date().getFullYear()} Vitl. All rights reserved
              </small>
            </li>
          </ul>
          <hr className={styles.hrMobile} />
          <ul className={styles.bottomColRight}>
            <li className={styles.hippaComplaint}>
              <ResponsiveResolutionImage
                url={hipaaImage}
                title="HIPAA compliant"
                width={110}
                height={40}
              />
            </li>
            <li>
              <a
                className={styles.link}
                href={`${process.env.GATSBY_VITL_HOST_NAME}/terms`}
                rel="noopener"
              >
                Terms and Conditions
              </a>
            </li>
            <li>
              <a
                className={styles.link}
                href={`${process.env.GATSBY_VITL_HOST_NAME}/privacy`}
                rel="noopener"
              >
                Privacy
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
